import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, FILEURL, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { useTranslation } from "../../locale/useTranslation";
import MyMultiSelect from "../../components/MyMultiSelect";
import BossDialog from "../../components/BossDialog";
import NodeTreeViewForm from "../MediaLibrary/NodeTreeView/NodeTreeViewForm";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import ToastNotification from "../../components/ToastNotification";

const NodeReport = () => {

  const blankDataItem = {
    Catalogue: {},
    Nodes: []
  }

  const lang = useTranslation();
  const [dataItem, setDataItem] = useState(blankDataItem);
  const [catalogues, setCatalogues] = useState([]);
  const [showNodePopup, setShowNodePopup] = useState(false);
  const [footerMessage, setFooterMessage] = useState('');
  const [gridData, setGridData] = useState([]);

  const borderStyle = {
    border: "1px solid #ced4da",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#FAFAFA"
  }

  useEffect(() => {
    loadcombo();
  }, []);

  const loadcombo = async () => {
    let catalogueRes = await API.getData(ENTITYNAME.Catalogues, { sort: { Description: 1 }, query: ['Archive', '!=', true] });
    setCatalogues(catalogueRes.data);
  }

  const onCatalogueChange = (e) => {
    setDataItem({
      Catalogue: e.value,
      Nodes: []
    });
  };

  const onNodesChange = (e) => {
    setDataItem(prev => ({
      ...prev,
      Nodes: e.value
    }));
  };

  const isValid = () => {
    if (!dataItem?.Catalogue?._id) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_catalogue_error_message });
      return false;
    }
    if (!dataItem.Nodes.length) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_node_error_message });
      return false;
    }
    return true;
  };

  const handleExport = async () => {
    if (!isValid()) return;

    setFooterMessage(lang.please_wait_export_message);
    const payload = {
      CatalogueId: dataItem.Catalogue._id,
      NodeIds: dataItem.Nodes.map(n => n._id)
    };

    const res = await API.getNodeReport(payload);

    if (res.success) {
      setGridData(res.gridData);
      window.open(FILEURL().BASEURL + 'downloadReport/' + res.fileName);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
      setFooterMessage(lang.successfully_download_success_message);
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      setFooterMessage(res.message);
    }
  };

  const handleSelectedNodes = (nodes) => {
    setDataItem(prev => ({
      ...prev,
      Nodes: nodes
    }));
    setShowNodePopup(false);
  };


  return (<>
    <h1 className="page-title txt-color-bludeDark">
      <i
        className="fa fa-table marlr"
        style={{ fontSize: "20px", color: "GrayText" }}
      ></i>
      <span>{lang.node_page_breadcrumb}</span>
    </h1>
    <div className="border p-2 form-group with-3d-effect row" style={borderStyle}>
      <div className="col-12">
        <div className="row">
          <div className="col-3">
            <label>{lang.catalogue_label} *</label>
            <DropDownList
              data={catalogues}
              name="Catalogue"
              textField="Description"
              dataItemKey="_id"
              value={dataItem.Catalogue}
              onChange={onCatalogueChange}
            />
          </div>
          <div className='col-5'>
            <label>{lang.nodes_label} *</label>
            <div className='d-flex'>
              <MyMultiSelect
                data={[]}
                name="Nodes"
                dataItemKey="_id"
                textField="Name"
                value={dataItem.Nodes}
                onChange={onNodesChange}
                style={{ flex: 1, width: "500px", marginRight: "10px" }}
              />
              <button
                type="button"
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                style={{ width: "28px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}
                onClick={() => setShowNodePopup(true)}
                title={lang.attach_nodes_button_tooltip}
              >
                <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div className="col mt-4">
            <ActionButton name={lang.export_button_text} onClick={handleExport} />
          </div>
        </div>
        <strong className='text-info' style={{ fontSize: "13px" }}>{footerMessage}</strong>
      </div>
    </div>
    <div className="row mt-4">
      <div className="col-12">
        <Grid data={gridData} style={{ height: '70vh' }} resizable={true}>
          <Column field="NodeCSID" title="Node Id" width="120px" />
          <Column field="NodeName" title="Node Name" width="180px" />
          <Column field="AssetId" title="Asset Id" width="140px" />
          <Column field="Title" title="Title" width="220px" />
          <Column field="Description" title="Description" width="280px" />
          <Column field="EpisodeNumber" title="Episode No" width="120px" />
          <Column field="SeasonNumber" title="Season No" width="120px" />
          <Column field="Duration" title="Duration" width="140px" />
          <Column field="MediaCategory" title="Media Category" width="160px" />
          <Column field="MediaType" title="Media Type" width="160px" />
          <Column field="MediaSubType" title="Media Sub Type" width="160px" />
          <Column field="Genres" title="Genres" width="220px" />
          <Column field="SubGenres" title="Sub Genres" width="220px" />
          <Column field="SeriesTitle" title="Series Title" width="220px" />
          <Column field="SeriesAssetId" title="Series Asset Id" width="160px" />
          <Column field="SeasonTitle" title="Season Title" width="220px" />
          <Column field="SeasonAssetId" title="Season Asset Id" width="160px" />
          <Column field="ProductionYear" title="Production Year" width="160px" />
          <Column field="PGRating" title="PG Rating" width="140px" />
          <Column field="CensorRating" title="Censor Rating" width="160px" />
          <Column field="Languages" title="Languages" width="220px" />
          <Column field="Keywords" title="Keywords" width="220px" />
          <Column field="MediaEpisodeSID" title="Episode SID" width="160px" />
          <Column field="ReleaseDate" title="Release Date" width="160px" />
          <Column field="ReferenceCode" title="Reference Code" width="160px" />
          <Column field="TotalRuns" title="Total Runs" width="140px" />
          <Column field="TotalRunTime" title="Total Run Time" width="160px" />
        </Grid>
      </div>
    </div>
    {showNodePopup && <BossDialog title={lang.select_nodes_dialog_header} width='600px' onClose={() => setShowNodePopup(false)}>
      <NodeTreeViewForm selectedCatalogueId={dataItem?.Catalogue?._id} isSaveButton={true} isMultiSelect={true} onClose={() => setShowNodePopup(false)} handleSelectedNodes={handleSelectedNodes} showCatalogue={false} />
    </BossDialog>}
  </>)
}


export default NodeReport